import MemoFavoritesNoAccount from "../icons/FavoritesNoAccount";
import { Button, ButtonText } from "../ui/button.component";
import styles from "./favorites-auth-guard.module.scss";
import { Auth } from "./auth.component";
import { useCallback, useState } from "react";
import { useArrowKeyNavigationOverlay } from "app/hooks/keyboard-navigation.hook";
import { Portal } from "../ui/portal";
import useModalScroll from "app/hooks/modal-scroll.hook";
import { useTranslate } from "app/hooks/lang";
import { useGoBackEvent } from "app/hooks/go-back.hook";

interface FavoritesAuthGuardProps {
  onClose?: VoidFunction;
}

export const FavoritesAuthGuard: React.FC<FavoritesAuthGuardProps> = ({
  onClose,
}) => {
  const t = useTranslate();
  const [showAuth, setShowAuth] = useState(false);
  const popupId = useGoBackEvent(
    "FavoritesAuthGuard",
    () => {
      setShowAuth(false);
    },
    showAuth
  );
  const authCloseCallback = useCallback(() => {
    setShowAuth(false);
  }, [setShowAuth]);
  return (
    <div>
      {showAuth ? (
        <Auth
          parentPopupId={popupId}
          onClose={authCloseCallback}
          onSuccess={onClose}
        />
      ) : (
        <div className={styles.no_account}>
          <div className={styles.icon}>
            <MemoFavoritesNoAccount />
          </div>
          <div className={styles.content}>
            <h3 className={styles.title}>{t("header.menu.favorites")}</h3>
            <p className={styles.subtitle}>{t("you-dont-have-favorites")}</p>
            <div data-navigate-row>
              <Button
                data-navigate-item
                onClick={() => setShowAuth(true)}
                className={styles.button}
              >
                {t("create-an-account")}
              </Button>
            </div>
            {onClose && (
              <>
                <br />
                <div data-navigate-row>
                  <ButtonText
                    data-navigate-item
                    onClick={() => onClose()}
                    className={styles.button}
                  >
                    {t("close")}
                  </ButtonText>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

interface FavoritesAuthGuardPopupProps {
  onClose: VoidFunction;
}
export const FavoritesAuthGuardPopup: React.FC<
  FavoritesAuthGuardPopupProps
> = ({ onClose }) => {
  const wrapperRef = useArrowKeyNavigationOverlay();
  useModalScroll();
  const goBackCallback = useCallback(() => {
    onClose();
  }, [onClose]);
  useGoBackEvent("FavoritesAuthGuardPopup", goBackCallback);
  return (
    <Portal>
      <div className={styles.wrapper} ref={wrapperRef}>
        <FavoritesAuthGuard onClose={onClose} />
      </div>
    </Portal>
  );
};
